module.exports = __webpack_public_path__ + "img/standard.4d265206.svg";